import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { t } from 'i18next';
import { DataContext } from '../../player/DataContext';
import '../../styles/widgets/popup/chartSizeAlertPopup.scss';
import ButtonComponent from '../../components/ButtonComponent';
var ChartSizeAlertPopup = function () {
    var _a = useContext(DataContext), setManiplulatorComponentVisible = _a.setManiplulatorComponentVisible, setSelectedManipulativeId = _a.setSelectedManipulativeId, setActiveManipulator = _a.setActiveManipulator;
    var onClose = function () {
        setSelectedManipulativeId('');
        setManiplulatorComponentVisible(false);
        setActiveManipulator('');
    };
    return (_jsx("div", { className: "eraserWrapper chartSizeAlertWrapper", onKeyDown: function (e) {
            if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                e.stopPropagation();
            }
        }, children: _jsxs("div", { className: "container", children: [_jsxs("div", { className: "upperPart", children: [_jsx("div", { className: "title", style: { fontWeight: 'bold' }, children: t('text.chartSize') }), _jsx("div", { className: "title", children: t('text.chartSizeMsg') }), _jsx("div", { className: "btnContainer", children: _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: onClose, ariaLabel: t('text.ok') }) })] }), _jsx("div", { className: "footerImageHolder", style: { backgroundImage: 'url(./assets/images/shareColourPatches.svg)' } })] }) }));
    // return (
    //   <div className="chartSizeAlertWrapper">
    //     <div className="chartSizeAlertContent">
    //       <div className="chartSizeAlertTitle">{t('text.chartSize')}</div>
    //       <div className="chartSizeAlertMessage">{t('text.chartSizeMsg')}</div>
    //     </div>
    //     <button className="chartSizeAlertOkBtn" onClick={onClose}>
    //       {t('text.ok')}
    //     </button>
    //   </div>
    // );
};
export default ChartSizeAlertPopup;
